import Layout from '@/layout'

export default {
	path: '/door-control',
	component: Layout,
	name: '门禁',
	id: 1900000,
	meta: {
		title: '门禁',
		roles: [1900000]
	},
	children: [
		// {
		//   path: 'door-control-role',
		//   name: '门禁权限',
		//   id: 130500,
		//   component: {
		//     render: (h) => h('router-view'),
		//   },
		//   meta: {
		//     title: '门禁权限',
		//     roles: [130500],
		//   },
		//   children: [
		//     {
		//       path: 'role',
		//       name: '门禁权限分配',
		//       id: 130510,
		//       meta: {
		//         title: '门禁权限分配',
		//         roles: [130510],
		//       },
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "dc-role" */ '@/leniuview/doorControl/accessControl/role'
		//         ),
		//     },
		//   ],
		// },
		{
			path: 'device',
			name: '门及门禁控制器管理',
			id: 1901000,
			component: {
				render: (h) => h('router-view')
			},
			meta: {
				title: '门及门禁控制器管',
				roles: [1901000]
			},
			children: [
				{
					path: 'door',
					name: '楼宇/门',
					id: 1901100,
					meta: {
						title: '楼宇/门',
						roles: [1901100]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-door" */ '@/leniuview/doorControl/device/door'
						)
				},
				{
					path: 'terminal',
					name: '门禁控制器',
					id: 1901200,
					meta: {
						title: '门禁控制器',
						roles: [1901200]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-terminal" */ '@/leniuview/doorControl/device/terminal'
						)
				},
				{
					path: 'custdoor',
					name: '人员管理',
					meta: {
						title: '人员管理',
						roles: [1901200],
						noCache: true
					},
					hidden: true,
					component: () =>
						import(
							/* webpackChunkName: "dc-custdoor" */ '@/leniuview/doorControl/device/terminal/custdoor'
						)
				}
			]
		},
		{
			path: 'accessControl',
			name: '群组设置',
			id: 1902000,
			component: {
				render: (h) => h('router-view')
			},
			meta: {
				title: '群组设置',
				roles: [1902000]
			},
			children: [
				{
					path: 'holiday',
					name: '假日',
					id: 1902100,
					meta: {
						title: '假日',
						roles: [1902100]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-holiday" */ '@/leniuview/doorControl/accessControl/holiday'
						)
				},
				{
					path: 'timeZone',
					name: '时区',
					id: 1902200,
					meta: {
						title: '时区',
						roles: [1902200]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-timeZone" */ '@/leniuview/doorControl/accessControl/timeZone'
						)
				},
				{
					path: 'inOutGroups',
					name: '进出群组',
					id: 1902300,
					meta: {
						title: '进出群组',
						roles: [1902300]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-inOutGroups" */ '@/leniuview/doorControl/accessControl/inOutGroups'
						)
				}
				// {
				//   path: 'pushData',
				//   name: '上传参数',
				//   id: 130206,
				//   meta: {
				//     title: '上传参数',
				//     roles: [130206],
				//   },
				//   component: () =>
				//     import(
				//       /* webpackChunkName: "dc-holiday" */ '@/leniuview/doorControl/accessControl/pushData'
				//     ),
				// },
			]
		},
		{
			path: 'role',
			name: '门禁权限分配',
			id: 1905000,
			component: {
				render: (h) => h('router-view')
			},
			meta: {
				title: '门禁权限分配',
				roles: [1905000]
			},
			children: [
				{
					path: 'auto',
					name: '自动分配权限',
					id: 1905100,
					meta: {
						title: '自动分配权限',
						roles: [1905100],
						noCache: true
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-text" */ '@/leniuview/doorControl/role/auto'
						)
				},
				{
					path: 'manual',
					name: '手动分配权限',
					id: 1905200,
					meta: {
						title: '手动分配权限',
						roles: [1905200],
						noCache: true
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-picture" */ '@/leniuview/doorControl/role/manual'
						)
				}
			]
		},
		{
			path: 'monitor',
			name: '实时监控',
			id: 1903000,
			component: {
				render: (h) => h('router-view')
			},
			meta: {
				title: '实时监控',
				roles: [1903000]
			},
			children: [
				// {
				//   path: 'text',
				//   name: '实时文字监控',
				//   id: 130301,
				//   meta: {
				//     title: '实时文字监控',
				//     roles: [130301],
				//     noCache: true,
				//   },
				//   component: () =>
				//     import(
				//       /* webpackChunkName: "dc-text" */ '@/leniuview/doorControl/monitor/text'
				//     ),
				// },
				{
					path: 'picture',
					name: '实时图文监控',
					id: 1903100,
					meta: {
						title: '实时图文监控',
						roles: [1903100],
						noCache: true
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-picture" */ '@/leniuview/doorControl/monitor/picture'
						)
				}
			]
		},
		{
			path: 'reportform',
			name: '门禁记录',
			id: 1904000,
			component: {
				render: (h) => h('router-view')
			},
			meta: {
				title: '门禁记录',
				roles: [1904000]
			},
			children: [
				{
					path: 'inout',
					name: '门进出记录',
					id: 1904100,
					meta: {
						title: '门进出记录',
						roles: [1904100]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-inout" */ '@/leniuview/doorControl/reportform/inout'
						)
				},
				{
					path: 'beginend',
					name: '人员进出记录',
					id: 1904200,
					meta: {
						title: '人员进出记录',
						roles: [1904200]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-beginend" */ '@/leniuview/doorControl/reportform/beginend'
						)
				},
				{
					path: 'log',
					name: '数据交互日志',
					id: 1904300,
					meta: {
						title: '数据交互日志',
						roles: [1904300]
					},
					component: () =>
						import(
							/* webpackChunkName: "dc-beginend" */ '@/leniuview/doorControl/reportform/log'
						)
				}
			]
		}
	]
}
